// extracted by mini-css-extract-plugin
export default {"signin":"Signin_signin__CmPLk","text":"Signin_text__FGC42"};